import './App.css';
import { Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
/* import { useParams } from "react-router-dom"; */
import Header from './Header/Header';
import Footer from './Footer/Footer';
import Cards from './Cards/Cards';
import Aside from './Aside/Aside';
import data from './data/data.js';
import Overlay from './Overlay/Overlay';
import Modal from './Modal/Modal';


function App() {
  const [showMenu, setShowMenu] = useState(false);//меню открыто - true/false
  const [openOverlay, setOpenOverlay] = useState(false); //overlay - true/false
  const [openModal, setopenModal] = useState(false); //modal - true/false
  /* const params = useParams(); */
  const mediaQuery = window.matchMedia('(max-width: 600px)')

  useEffect(() => {
    document.title = "Айкидо по-японски"
  }, []);

  useEffect(() => {
    if(openOverlay) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
      setopenModal(false)
    }
  }, [openOverlay]);

  useEffect(() => {
    if(showMenu) setopenModal(false);
  }, [showMenu]);

  function handlerChange(e) {
    //клик по меню
    if(e.currentTarget.tagName !== 'BUTTON') {
      setShowMenu(!showMenu);
      //desktop
      if(openOverlay && !mediaQuery.matches) {//если есть оверлей на десктопе
        setOpenOverlay(false);//оверлей закрыть
      }
      //mobile
      if (mediaQuery.matches) {
        if(showMenu) {
          setOpenOverlay(false);
        } else {
          setOpenOverlay(true);
        }
      }

    } else if(e.currentTarget.tagName === 'BUTTON') {//клик по кнопке "инфо"
      if(showMenu) {//если меню открыто и оверлей есть
        setShowMenu(false);//меню закрыть
        setOpenOverlay(true);//оверлей оставить
      } else {
        setOpenOverlay(!openOverlay);
      }
      setopenModal(!openModal);
    }
  }

  function closeMenu() {
    if(showMenu){
      setShowMenu(false)
    }
    setOpenOverlay(false);
  }

  return (
    <div className="App flex flex-col justify-between">
      <Aside arr={data} open={showMenu} closeMenu={() => {closeMenu()}} />
      <Header open={showMenu} myChange={handlerChange} info={(e)=> {handlerChange(e)}}/>
      <main className='container mx-auto flex-3 py-8 px-8 h-full'>

        <Routes>
          <Route index path="/" element={<Cards arr={data} cat="cat" />}/>
          <Route path="*" element={<Cards arr={data} cat="cat" />}/>
            {data.map((item, i) => {
            return <Route 
            key={i} 
            item={item}
            path="/:category" 
            element={<Cards arr={data} cat="cat"/>}
            />

          })}
        </Routes>
        
      </main>
      <Footer/>
      <Overlay show={openOverlay} onClick={(e)=> {closeMenu(e)}}/>
      <Modal show={openModal}/>
    </div>
  );
}

export default App;
